module.exports = __webpack_public_path__ + "static/media/NutritionComplete_fr.687a98e9.png";